// extracted by mini-css-extract-plugin
export default {"cls1":"Ot6bOY6TvvJOGooXslE7","cls2":"w73O32_VI1aHvjlCQJyF Ot6bOY6TvvJOGooXslE7"};